import React, {useEffect, useState} from "react";
import {
  Typography,
  Grid,
  Button,
  FormControlLabel,
  Checkbox,
  Divider,
  LinearProgress,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  FormHelperText,
} from '@material-ui/core';
import {Link} from 'react-router-dom';
import useAxios from "axios-hooks";
import {Alert} from "@material-ui/lab";

import BaseAuth from './BaseAuth';
import {useStyles} from './styles';
import {signupRequest} from "../../../Api";
import {BUSINESS_CATEGORIES} from "./constants";

import TextField from 'Components/Universal/TextField';

const SignUpPage = () => {
  const classes = useStyles();

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    password2: '',
    first_name: '',
    last_name: '',
    business_name: '',
    business_category: '',
    phone_number: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
  });

  const [submited, setSubmitted] = useState(false);

  const [changedFields, setChangedFields] = useState([]);

  const fieldChange = e => {
    if (formData[e.target.name] !== e.target.value) {
      if (!changedFields.find(field => field === e.target.name)) {
        setChangedFields([...changedFields, e.target.name]);
      }
    }
    setFormData({...formData, [e.target.name]: e.target.value});
  };

  const [errorMsg, setErrorMsg] = useState('');
  const [signUpSuccess, setSignUpSuccess] = useState(false);
  const [{error, loading, response}, signUpAction] = useAxios(signupRequest(), { manual: true });

  useEffect(() => {
    if (error) {
      setErrorMsg(`Unhandled error from our server: ${error.message}`);
    } else if (response && response.data) {
      if (response.data.error) {
        setErrorMsg(response.data.message);
      } else {
        setSignUpSuccess(true);
      }
    }
  }, [response, error]);

  const handleSubmit = e => {
    e.preventDefault();
    setErrorMsg('');
    const requiredFields = ['email', 'first_name', 'last_name', 'business_name', 'business_category', 'phone_number', 'address1', 'address2', 'city', 'zip', 'state'];
    setSubmitted(true);
    for (let i = 0; i < requiredFields.length; i += 1) {
      if (formData[requiredFields[i]] === '')
        return;
    }
    if (formData.password !== formData.password2) {
      setErrorMsg("Passwords are not matching. Please make sure Password and Confirm Password fields are the same");
      return;
    }

    const data = {};
    Object.keys(formData).map(k => data[`advertiser_${k}`] = formData[k]);
    signUpAction({ data });
  };

  return (
    <BaseAuth title="Complete this form to create your Focusloop account">
      {signUpSuccess ? (
        <Alert color='success'>
          Congratulations, You have successfully signed up! Please check your "{formData.email}"
          and click the verification link that we've sent to that email.
        </Alert>
      ) : (
        <>
          <div
            style={{
              padding: 32,
              borderRadius: 4,
              backgroundColor: 'white',
              marginBottom: '32px'
            }}
          >
            <form className={classes.form} noValidate onSubmit={handleSubmit}>
              <p>&nbsp;</p>
              <Typography variant="h5" gutterBottom>
                Account Info
              </Typography>
              <Divider />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Business Email"
                name="email"
                autoComplete="email"
                value={formData.email}
                onChange={fieldChange}
                error={formData.email === '' && (changedFields.find(field => field === 'email') || submited)}
                helperText={(formData.email === '' && (changedFields.find(field => field === 'email')  || submited)) && 'This information is required'}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                value={formData.password}
                onChange={fieldChange}
                error={formData.password === '' && (changedFields.find(field => field === 'password') || submited)}
                helperText={(formData.password === '' && (changedFields.find(field => field === 'password') || submited)) && 'This information is required'}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password2"
                label="Confirm Password"
                type="password"
                id="password2"
                autoComplete="current-password"
                value={formData.password2}
                onChange={fieldChange}
                error={formData.password2 === '' && (changedFields.find(field => field === 'password2') || submited)}
                helperText={(formData.password2 === '' && (changedFields.find(field => field === 'password2') || submited)) && 'This information is required'}
              />
              <p>&nbsp;</p>
              <Typography variant="h5" gutterBottom>
                Personal Info
              </Typography>
              <Divider />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="first_name"
                label="First Name"
                name="first_name"
                value={formData.first_name}
                onChange={fieldChange}
                error={formData.first_name === '' && (changedFields.find(field => field === 'first_name') || submited)}
                helperText={(formData.first_name === '' && (changedFields.find(field => field === 'first_name') || submited)) && 'This information is required'}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="last_name"
                label="Last Name"
                name="last_name"
                value={formData.last_name}
                onChange={fieldChange}
                error={formData.last_name === '' && (changedFields.find(field => field === 'last_name') || submited)}
                helperText={(formData.last_name === '' && (changedFields.find(field => field === 'last_name') || submited)) && 'This information is required'}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="phone_number"
                label="Phone Number"
                name="phone_number"
                value={formData.phone_number}
                onChange={fieldChange}
                error={formData.phone_number === '' && (changedFields.find(field => field === 'phone_number') || submited)}
                helperText={(formData.phone_number === '' && (changedFields.find(field => field === 'phone_number') || submited)) && 'This information is required'}
              />
              <p>&nbsp;</p>
              <Typography variant="h5" gutterBottom>
                Business Info
              </Typography>
              <Divider />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="business_name"
                label="Business Name"
                name="business_name"
                value={formData.business_name}
                onChange={fieldChange}
                error={formData.business_name === '' && (changedFields.find(field => field === 'business_name')  || submited)}
                helperText={(formData.business_name === '' && (changedFields.find(field => field === 'business_name') || submited)) && 'This information is required'}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="address1"
                label="Business Address"
                name="address1"
                value={formData.address1}
                onChange={fieldChange}
                error={formData.address1 === '' && (changedFields.find(field => field === 'address1') || submited)}
                helperText={(formData.address1 === '' && (changedFields.find(field => field === 'address1') || submited)) && 'This information is required'}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="address2"
                label="Business Suite Number"
                name="address2"
                value={formData.address2}
                onChange={fieldChange}
                error={formData.address2 === '' && (changedFields.find(field => field === 'address2') || submited)}
                helperText={(formData.address2 === '' && (changedFields.find(field => field === 'address2') || submited)) && 'This information is required'}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="city"
                label="Business City"
                name="city"
                value={formData.city}
                onChange={fieldChange}
                error={formData.city === '' && (changedFields.find(field => field === 'city') || submited)}
                helperText={(formData.city === '' && changedFields.find(field => field === 'city')) && 'This information is required'}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="state"
                label="Business State"
                name="state"
                value={formData.state}
                onChange={fieldChange}
                error={formData.state === '' && (changedFields.find(field => field === 'state') || submited)}
                helperText={(formData.state === '' && changedFields.find(field => field === 'state')) && 'This information is required'}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="zip"
                label="Business Zip"
                name="zip"
                value={formData.zip}
                onChange={fieldChange}
                error={formData.zip === '' && (changedFields.find(field => field === 'zip') || submited)}
                helperText={(formData.zip === '' && (changedFields.find(field => field === 'zip') || submited)) && 'This information is required'}
              />
              <FormControl className={classes.formControl} error={formData.business_category === '' && submited}>
                <InputLabel id="business_category-field">Business Category</InputLabel>
                <Select
                  labelId="business_category-field"
                  id="business_category-label"
                  name="business_category"
                  value={formData.business_category}
                  onChange={fieldChange}
                >
                  {BUSINESS_CATEGORIES.map(option => (
                    <MenuItem key={option} value={option}>{option}</MenuItem>
                  ))}
                </Select>
                {(formData.business_category === '' && submited) && (<FormHelperText>Error</FormHelperText>)}
              </FormControl>
              <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="I accept terms of Privacy Policy"
              />

              {loading && <LinearProgress />}
              {errorMsg && errorMsg.length > 0 && (
                <Alert severity="error">{errorMsg}</Alert>
              )}

              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={`${classes.submit} ${classes.mainButton}`}
                style={{ borderWidth: 3 }}
              >
                Sign Up
              </Button>
            </form>
          </div>
          <Grid container style={{ marginBottom: '32px' }}>
            <Grid item xs>
              <Link to="/auth/forgot" variant="body2" style={{ color: 'white' }}>
                Forgot password?
              </Link>
            </Grid>
            <Grid item>
              <Link to='/auth/signin' variant="body2" style={{ color: 'white' }}>
                Already have an account? Sign In
              </Link>
            </Grid>
          </Grid>
        </>
      )}
    </BaseAuth>
  );
};

export default SignUpPage;
